/**
 * Inizializza il Drag and Drop tra i moduli dell'accordion e le textarea del palinsesto.
 * * @param {string} [dragSelectors='.elemento-trascinabile'] - Il selettore CSS degli elementi da trascinare.
 * @param {string} [dropContainerId='settimana-container'] - L'ID del container che riceve il drop (le giornate).
 */
export function dragAndDrop() {
    // 1. Attiva il trascinamento sulle frasi dell'accordion
    document.querySelectorAll('.elemento-trascinabile').forEach(el => {
        el.addEventListener('dragstart', (e) => {
            const testoDaCopiare = e.currentTarget.dataset.testo;
            e.dataTransfer.setData('text/plain', testoDaCopiare);
            e.currentTarget.classList.add('opacity-50'); 
        });

        el.addEventListener('dragend', (e) => {
            e.currentTarget.classList.remove('opacity-50'); 
        });
    });

    // 2. Gestisci gli eventi sul container della settimana
    const containerSettimana = document.getElementById('settimana-container');
    if (!containerSettimana) return; 

    containerSettimana.addEventListener('dragover', (e) => {
        if (e.target.tagName === 'TEXTAREA') {
            e.preventDefault(); 
            e.target.classList.add('border-primary'); 
        }
    });

    containerSettimana.addEventListener('dragleave', (e) => {
        if (e.target.tagName === 'TEXTAREA') {
            e.target.classList.remove('border-primary');
        }
    });

    containerSettimana.addEventListener('drop', (e) => {
        if (e.target.tagName === 'TEXTAREA') {
            e.preventDefault();
            
            const textarea = e.target;
            textarea.classList.remove('border-primary');

            const dataText = e.dataTransfer.getData('text/plain');
            if (!dataText || dataText === "undefined") return;

            const valoreAttuale = textarea.value.trim();
            
            if (valoreAttuale !== '') {
                textarea.value = valoreAttuale + ', ' + dataText;
            } else {
                textarea.value = dataText;
            }

            textarea.dispatchEvent(new Event('input', { bubbles: true }));
        }
    });
}